<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate('', false)"
  (sortObject)="getSortItems($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
>
  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-px-4 !tw-py-2">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- title -->
        <td class="tw-py-2">
          <td-value copyToClipboard [value]="item?.title"></td-value>
        </td>

        <!-- customerDomainName -->
        <td class="tw-py-2">
          <td-value
            copyToClipboard
            [value]="item?.customerDomainName"
          ></td-value>
        </td>

        <!-- isActive -->
        <td>
          <td-value type="boolean" [value]="item?.isActive"></td-value>
        </td>

        <!-- isRequiredToSeen -->
        <td>
          <td-value type="boolean" [value]="item?.isRequiredToSeen"></td-value>
        </td>

        <!-- displayForAllSubOrganizations -->
        <td>
          <td-value
            type="boolean"
            [value]="item?.displayForAllSubOrganizations"
          ></td-value>
        </td>

        <!-- created -->
        <td class="tw-py-2">
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <!-- startDate -->
        <td class="tw-py-2">
          <td-value type="date" [value]="item?.startDate"></td-value>
        </td>

        <!-- endDate -->
        <td class="tw-py-2">
          <td-value type="date" [value]="item?.endDate"></td-value>
        </td>

        <!------------------------------- operations -------------------------------->
        <td class="sticky-td">
          <!-- open menu btn -->
          <div app-menu-btn [matMenuTriggerFor]="menu" [isShowDotsMenu]="true"></div>


          <!-- menu -->
          <mat-menu #menu="matMenu" xPosition="before">
            <!-- edit button -->
            <div app-menu-btn icon="edit" (click)="onUpdate(item?.id)">
            </div>
          
            <!-- transactions button -->
            <div app-menu-btn icon="mdi mdi-account-group mdi-20px" color="yellow" [title]="'common.informationUsersSeen'"
              (click)="onShowInformationUsersSeen('informationUsersSeen', item.id)"></div>
          
            <!-- delete button -->
            <!-- *ngIf="permissionService.userState()?.isSuperAdmin || permissionService.userState()?.isAdmin" -->
            <div app-menu-btn icon="delete" (click)="onDelete(item.id, item.title)">
            </div>
          
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-informations-form
    [formPageConfig]="formPageConfig"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-informations-form>
</ng-container>

<!-- Audit -->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    [sortReferenceId]="false"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!--------------------------------------- help --------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
